module.exports = __webpack_public_path__ + "img/xieshou-banner.91c976b6.png";